import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {ListBreadcrumbSeoValueObject} from '../../seo/ValueObjects/ListBreadcrumbSeoValueObject.js'
import {SeoHelmetValueObject} from './SeoHelmetValueObject.js'

export class VehicleConfiguratorSeoDataValueObject extends ValueObject {
  #breadcrumbs
  #helmet

  constructor({breadcrumbs, helmet}) {
    super()
    this.#breadcrumbs = breadcrumbs
    this.#helmet = helmet
  }

  get breadcrumbs() {
    return this.#breadcrumbs.value
  }

  get helmet() {
    return this.#helmet.value
  }

  get value() {
    return {
      breadcrumbs: this.#breadcrumbs.value,
      helmet: this.#helmet.value
    }
  }

  static #buildBreadcrumbs({makeName, makeSlug, modelName, modelSlug}) {
    const hasMake = Boolean(makeName)
    const hasModel = Boolean(modelName)
    const breadcrumbs = [
      {
        label: 'Configurador',
        ...(hasMake ? {url: `/configurador/`} : {})
      },
      ...(hasMake ? [{label: makeName, ...(hasModel ? {url: `/configurador/${makeSlug}/`} : {})}] : []),
      ...(hasModel ? [{label: modelName}] : [])
    ].filter(Boolean)

    return breadcrumbs
  }

  static #buildCanonical({makeName, makeSlug, modelName, modelSlug}) {
    const protocol = ConfigContext.get('URL_PROTOCOL')
    const host = ConfigContext.get('HOST_DOMAIN')
    const siteUrl = `${protocol}${host}`
    const hasMake = Boolean(makeName)
    if (!hasMake) {
      return `${siteUrl}/configurador/`
    }
    const hasModel = Boolean(modelName)
    return `${siteUrl}/configurador/${makeSlug}${hasModel ? `/${modelSlug}` : ''}/`
  }

  static #buildDescription({makeName, makeSlug, modelName, modelSlug}) {
    const hasMake = Boolean(makeName)
    if (!hasMake) {
      return 'Configura tu coche ideal en coches.net. Descubre todos los modelos y configura el modelo que mejor se adapta a tus necesidades'
    }
    const hasModel = Boolean(modelName)
    const description = hasModel
      ? `Configura tu ${makeName} ${modelName} ideal en coches.net. Personaliza y conoce todos los detalles del nuevo ${modelName}, desde motorización hasta equipamiento. ¡Configura tu ${makeName} ${modelName} perfecto!`
      : `Configura tu ${makeName} ideal en coches.net. Descubre todos los modelos nuevos de ${makeName} y configura el modelo que mejor se adapta a tus necesidades.`

    return description
  }

  static #buildTitle({makeName, makeSlug, modelName, modelSlug}) {
    const hasMake = Boolean(makeName)
    if (!hasMake) {
      return 'Configurador de coches nuevos | coches.net'
    }
    const hasModel = Boolean(modelName)
    return hasModel
      ? `Configurador de ${makeName} ${modelName} nuevos | coches.net`
      : `Configurador de ${makeName} nuevos | coches.net`
  }

  static #buildH1({makeName, modelName}) {
    return `Configurador ${makeName} ${modelName}`.trim()
  }

  static create({makeName = '', makeSlug, modelName = '', modelSlug}) {
    const breadcrumbs = this.#buildBreadcrumbs({makeName, makeSlug, modelName, modelSlug})
    const canonical = this.#buildCanonical({makeName, makeSlug, modelName, modelSlug})
    const description = this.#buildDescription({makeName, makeSlug, modelName, modelSlug})
    const h1 = this.#buildH1({makeName, modelName})
    const title = this.#buildTitle({makeName, makeSlug, modelName, modelSlug})

    return new VehicleConfiguratorSeoDataValueObject({
      breadcrumbs: ListBreadcrumbSeoValueObject.create({value: breadcrumbs}),
      helmet: SeoHelmetValueObject.create({
        h1,
        title,
        description,
        canonical,
        scripts: []
      })
    })
  }
}
